import React, { lazy, Suspense } from 'react';
import { CenteredSpinner } from '@components/ui/feedback/CenteredSpinner';
import { FeatureGates, useFeatureGate } from '@services/statsig';

const LegacyPatientPage = lazy(() => import('../components/Patient/PatientDetailView'));
const NewPatientPage = lazy(() =>
  import('@features/patient-page').then(m => ({ default: m.PatientPage })),
);
const PatientPageRedesignTestBanner = lazy(() =>
  import('@features/patient-page').then(m => ({ default: m.PatientPageRedesignTestBanner })),
);

export const PatientPageRoute: React.FC = () => {
  const isNewPatientPage = useFeatureGate(FeatureGates.SERVER_DRIVEN_PATIENT_PAGE);
  // Gate the lazy-loaded banner here so legacy-page users not in the test
  // don't fetch the banner module. The banner self-checks the same gate, so
  // mounting it would be safe — this is purely a fetch-avoidance optimization.
  const isV3TestEnabled = useFeatureGate(FeatureGates.PATIENT_PAGE_V3_TEST_2026_05);

  return (
    <Suspense fallback={<CenteredSpinner sx={{ height: '50vh' }} />}>
      {isV3TestEnabled && <PatientPageRedesignTestBanner />}
      {isNewPatientPage ? <NewPatientPage /> : <LegacyPatientPage />}
    </Suspense>
  );
};
